import React, { lazy, Suspense } from "react";
import "./Welcome.scss";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { FaHeadset } from "@react-icons/all-files/fa/FaHeadset";
import { FaHandHoldingHeart } from "@react-icons/all-files/fa/FaHandHoldingHeart";
import { FaClipboardList } from "@react-icons/all-files/fa/FaClipboardList";

function Welcome() {
  const navigate = useNavigate();
  const LazyCountUp = lazy(() => import("react-countup"));

  // TODO: Improve the performance

  return (
    <div className="welcome-container">
      <div className="welcome-content">
        {/* Main Section */}
        <div className="welcome__message">
          {/* <img src={CompanyLogo} alt="SeizureCare Logo" className="main-logo" /> */}

          {/* Large Heading */}
          <h1 className="main-title">The Future of Epilepsy Care</h1>

          {/* Subtitle */}
          <p className="subtitle">
            At SeizureCare, we revolutionize epilepsy management with
            cutting-edge technology, 24/7 support, and expert-driven analysis to
            improve patient outcomes worldwide.
          </p>

          {/* Info Section */}
          <div className="info-section">
            <div className="info-stats">
              <div className="stat">
                <FaHeadset size={"2rem"} color="#6a1b9a" />
                <h2>
                  <Suspense fallback={<span>Loading...</span>}>
                    <LazyCountUp start={0} end={24} duration={1} />
                    /7
                  </Suspense>
                </h2>
                <p>Support Available</p>
              </div>
              <div className="stat">
                <FaHandHoldingHeart size={"2rem"} color="#6a1b9a" />
                <h2>
                  <Suspense fallback={<span>Loading...</span>}>
                    <LazyCountUp
                      start={0}
                      end={1000}
                      duration={1.5}
                      separator=","
                    />
                  </Suspense>
                  +
                </h2>
                <p>Patients Helped</p>
              </div>
              <div className="stat">
                <FaClipboardList size={"2rem"} color="#6a1b9a" />
                <h2>
                  <Suspense fallback={<span>Loading...</span>}>
                    <LazyCountUp start={0} end={15} duration={1} />+
                  </Suspense>
                </h2>
                <p>Years of Experience</p>
              </div>
            </div>
            <div className="info-actions">
              <Button
                variant="contained"
                size="large"
                className="btn btn-primary"
                onClick={() => navigate("/services")}
              >
                Explore Services
              </Button>
              <Button
                variant="outlined"
                size="large"
                className="btn btn-secondary"
                onClick={() => navigate("/contact")}
              >
                Contact Us
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Welcome;
